<template>
  <div class="products">
    <h1>Nuovo Prodotto</h1>
      <div class="form">
        <div>
          <input type="text" name="name" placeholder="NOME" v-model="name">
        </div>
        <div>
          <input type="text" name="ean" placeholder="EAN" v-model="ean">
        </div>
        <div>
          <input type="text" name="sku" placeholder="FID" v-model="sku">
        </div>
        <div>
          <input type="number" name="bprice" placeholder="PREZZO ACQUISTO" v-model="bprice">
        </div>
        <div>
          <input type="number" name="price" placeholder="PREZZO SOGLIA" v-model="price">
        </div>

        <div>
          <button class="app_btn" @click="addProduct">Salva</button>
        </div>

        <div v-for="website in websitesmap" v-bind:key="website">
          <div>
              <a :href="website.baseurl" target="_blank">{{ website.name }}</a><!-- - {{website._id}}-->
          </div>
          <input :name="website._id + '-input'" type="text" placeholder="" v-model="website.value">
        </div>

        <div>
          <button class="app_btn" @click="addProduct">Salva</button>
        </div>
      </div>
  </div>
</template>

<script>
import ProductsService from '@/services/ProductsService'
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'NewProduct',
  data () {
    return {
      name: '',
      ean: '',
      sku: '',
      bprice: 0,
      price: 0,
      websites: {},
      websitesmap: []
    }
  },
  async mounted () {
      await this.getWebsites()
      await this.readUrl()
  },
  methods: {
    async getWebsites () {
      const response = await WebsitesService.fetch()
      // console.log(response.data.websites)
      this.websitesmap = response.data.websites
    },
    async readUrl () {
        // console.log('readUrl')
        // console.log(this.$route.query.sku)
        this.name = this.$route.query.name
        this.ean = this.$route.query.ean
        this.sku = this.$route.query.sku
        this.price = this.$route.query.price
        this.bprice = this.$route.query.bprice
        // var link = this.$route.query.link
        for (var website in this.websitesmap) {
            // console.log(this.websitesmap[website])
            if (this.websitesmap[website]._id === '5c9d06465113ce29c23e462f') {
                this.websitesmap[website].value = this.$route.query.link
            }
            if (this.websitesmap[website]._id === '5ca60480628a604ecda54af9') {
                this.websitesmap[website].value = this.$route.query.blink
            }
            if (this.websitesmap[website]._id === '5ca003f94b65f1193e49be3f') {
                this.websitesmap[website].value = this.$route.query.link
            }
            if (this.websitesmap[website]._id === '5cb7395b563b627e5b7c5b6c') {
                this.websitesmap[website].value = this.$route.query.plink
            }
            // console.log(this.websitesmap[website])
        }

      // const response = await WebsitesService.fetch()
      // this.websitesmap = response.data.websites
    },
    async addProduct () {
      let product = {
        id: this.$route.params.id,
        name: this.name,
        ean: this.ean,
        sku: this.sku,
        bprice: this.bprice,
        price: this.price,
        websites: {}
      }
      for (var website in this.websitesmap) {
        // console.log(website._id)
        // console.log(this.websites[website._id])
        var id = this.websitesmap[website]._id
        if (!product.websites[id]) {
          product.websites[id] = ''
        }
        product.websites[id] = this.websitesmap[website].value
      }
      // console.log(product)
      await ProductsService.add(product)
      this.$router.push({ name: 'Products' })
    }
  }
}
</script>
<style type="text/css">
.form input, .form textarea {
  width: 500px;
  padding: 10px;
  border: 1px solid #e0dede;
  outline: none;
  font-size: 12px;
}
.form div {
  margin: 20px;
}
.app_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NewProduct.vue